import { useMutation, gql } from '@apollo/client';
import {
  DeletarUnidadeMutation,
  DeletarUnidadeMutationVariables,
} from './__generated__/DeletarUnidadeMutation';

const DELETAR_UNIDADE_MUTATION = gql`
  mutation DeletarUnidadeMutation($id_unidade: Int!) {
    deletarUnidade(id_unidade: $id_unidade) {
      id_unidade
    }
  }
`;

const useDeletarUnidadeMutation = () => {
  return useMutation<DeletarUnidadeMutation, DeletarUnidadeMutationVariables>(
    DELETAR_UNIDADE_MUTATION
  );
};

export { useDeletarUnidadeMutation };
